import { render, staticRenderFns } from "./CatNicknameDialogBase.vue?vue&type=template&id=d33b3ab4&scoped=true"
import script from "./CatNicknameDialogBase.vue?vue&type=script&lang=ts"
export * from "./CatNicknameDialogBase.vue?vue&type=script&lang=ts"
import style0 from "./CatNicknameDialogBase.vue?vue&type=style&index=0&id=d33b3ab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d33b3ab4",
  null
  
)

export default component.exports